/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { IVillageSuggest } from '../../../types/village';
import { trackGeoSuggestItemClick } from '../../../utils/analytics';
import { VillageIcon } from '../../icons';
import { ListGroup, ListItem } from './ListGroup';
import { getSuggestLinkText } from './getSuggestLinkText';
import * as styles from './index.css';

interface IRoadsSuggestionsProps {
  textValue: string;
  suggests: IVillageSuggest[];
}

export const VillageSuggestions: React.FC<IRoadsSuggestionsProps> = props => {
  const { suggests, textValue } = props;

  return (
    <ListGroup title="Посёлки" icon={<VillageIcon />}>
      {suggests.map(suggest => (
        <ListItem key={`suggestion-${suggest.id}`}>
          <a
            className={styles['list-item_link']}
            href={suggest.url ?? ''}
            target="_blank"
            rel="nofollow noopener"
            onClick={() => trackGeoSuggestItemClick('KP/cian')}
          >
            <span>{getSuggestLinkText(`КП «${suggest.name}»`, textValue)}</span>
            <div className={styles['list-item_description']}>{suggest.address}</div>
            <div className={styles['list-item_icon']} />
          </a>
        </ListItem>
      ))}
    </ListGroup>
  );
};
